import { Injectable } from '@angular/core';

@Injectable()
export class OutlayColumnsConfigService {

  constructor() { }

  getColumnsConfig(aliasName: string): Object {

      let columns: Object = {};

      switch (aliasName){
          case 'beeztel':
              columns = {
                  pk: {title: '#'},
                  lang: {title: 'Lang', width: '5%'},
                  created_at: {title: 'Created at'},
                  //pk_campania: {title: 'Pk campaign'},
                  element: {title: 'Phone'},
                  phone_type: {title: 'Phone type'},
                  call_price_type: {title: 'Call price type'},
                  status: {title: 'Status'},
                  response: {title: 'Response'},
                  //timezone: {title: 'Timezone'},
                  call_provider: {title: 'Call provider'},
                  //dialedtime: {title: 'Dialed time'},
                  call_time: {title: 'Call time'},
                  redir_time: {title: 'Redir time'},
                  talking_time: {title: 'Talk time'},
                  total_time: {title: 'Total time'},
                  call_price: {title: 'Call price'},
                  call_outlay: {title: 'Call outlay'},
              };
              break;
          case 'chacon_sms':
              columns = {
                  pk: {title: '#'},
                  lang: {title: 'Lang'},
                  created_at: {title: 'Created at'},
                  element: {title: 'Phone'},
                  phone_type: {title: 'Phone type'},
                  status: {title: 'Status'},
                  response: {title: 'Response'},
                  call_outlay: {title: 'Call outlay'}
              }
      }

      return columns;
  }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/outlay/services/outlay-columns-config.service.ts